import { PrimaryButton, Pivot, PivotItem, Spinner } from '@fluentui/react';
import { Toggle as MSToggle, Dropdown as MSDropdown } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Prompt, useParams } from 'react-router-dom';
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';
import TextField from '../../../../Forms/TextField';
import Toggle from '../../../../Forms/Toggle';
import FluentSelect from '../../../../Forms/FluentSelect';
import DropDown from '../../../../Forms/DropDown';
import ImageGallery from '../../../../Forms/ImageGallery';
import Select from "react-select";
import { FixedSizeList as List } from "react-window";
import * as Yup from 'yup';
import { getCtaToolOptions } from './ctaToolEligibility';

const validationSchema = Yup.object().shape({
    slug: Yup.string().required('Slug is required'),
    title: Yup.string().required('Title is required'),
    description: Yup.string().required('Description is required'),
    linkText: Yup.string().required('Link Text is required'),
    linkUrl: Yup.string().required('Link Url is required'),
    imageUrl: Yup.string().required('Image Url is required'),
    conTags: Yup.array().when(['showOnArticles', 'showOnStart', 'showOnInfographics', 'showOnVideos'], {
        is: (showOnArticles, showOnStart, showOnInfographics, showOnVideos) =>
            showOnArticles || showOnStart || showOnInfographics || showOnVideos,
        then: Yup.array().min(1, 'At least one tag must be selected when an option is toggled on')
    }),
    countries: Yup.array().when('countryOnOffDefault', {
        is: false, // when countryOnOffDefault is turned off
        then: Yup.array().min(1, 'At least one country must be selected when countryOnOffDefault is off')
    }),
    tools: Yup.array().when('showOnTools', {
        is: true, // when showOnTools is on
        then: Yup.array().min(1, 'At least one tool must be selected when showOnTools is on')
    }),
    units: Yup.array().when('unitOnOffDefault', {
        is: false, // when unitOnOffDefault is off
        then: Yup.array().min(1, 'At least one unit must be selected when unitOnOffDefault is off')
    })
});

const CustomMenuList = ({ children, ...props }) => {
    const height = 35;
    const itemCount = children.length;
    const totalHeight = Math.min(300, itemCount * height);

    return (
        <List height={totalHeight} itemCount={itemCount} itemSize={height} width="100%">
            {({ index, style }) => (
                <div
                    style={{
                        ...style,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        padding: "0 8px",
                        boxSizing: "border-box",
                    }}
                    title={children[index]?.props?.children}
                >
                    {children[index]}
                </div>
            )}
        </List>
    );
};

const dropdownOptions = [
    { value: 1, label: '5' },
    { value: 2, label: '4' },
    { value: 3, label: '3' },
    { value: 4, label: '2' },
    { value: 5, label: '1' },
];
const newCoBrandSettingsObject = {
    callToActionId: null,
    cobrandId: null,
    conTags: [],
    countries: [],
    countryOnOffDefault: true,
    description: null,
    imageUrl: null,
    linkText: null,
    linkUrl: null,
    onForInternational: false,
    onForUs: true,
    priorityOnCustomClientPage: null,
    showOnArticles: false,
    showOnInfographics: false,
    showOnJournals: false,
    showOnMeditations: false,
    showOnStart: false,
    showOnTools: false,
    showOnVideos: false,
    slug: null,
    title: null,
    tools: [],
    unitOnOffDefault: true,
    units: [],
};

const CTA = () => {
    const { callToActionId: callToActionId } = useParams();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);

    const [{ data: cta, loading: loading }, refetch] = useAxios(`call-to-action?CallToActionId=${callToActionId}&Admin=true`);

    const [{ data: tags, loading: loadingTags }] = useAxios('courses/con-tags');
    const conTags = tags && tags.map(tag => ({ value: tag.id, label: tag.name }));

    const [{ data: countries, loading: loadingCountries }] = useAxios('courses/countries');
    const countryOptions = countries && countries.map(c => ({ value: c.id, label: c.name }));

    const [{ data: tools, loading: loadingTools }] = useAxios('/resources/tools/all-tools');

    const [{ data: units, loading: loadingUnits }] = useAxios('/internal/cobrand/all-client-schools');
    let unitsFormated = units && units.map(u => ({ value: u.clientSchoolId, label: u.schoolName, coBrandId: u.coBrandId }));

    const [{ data: cobrands, loading: loadingCobrands }] = useAxios('/internal/cobrands');
    const cobrandsOptions = cobrands && cobrands
        .map(u => ({ value: u.cobrandId, label: u.name }))
        .sort((a, b) => a.label.localeCompare(b.label));

    const [{ data, loading: submitting }, submitForm] = useAxios(
        { url: `call-to-action` },
        { manual: true },
    );

    if (loading) {
        return <Spinner className="absolute-center" text="Loading Cobrand Hub Settings..." />;
    }

    const handleToggleChange = (checked, setFieldValue) => {
        if (!checked) {
            setFieldValue('priorityOnCustomClientPage', null)
        }
        setIsDropdownVisible(checked);
    };


    return (
        <Formik
            initialValues={
                cta
                    ? {
                        ...cta.items[0]
                    }
                    : newCoBrandSettingsObject
            }
            validationSchema={validationSchema}
            onSubmit={async (values, { resetForm }) => {
                let result;
                result = await submitForm({
                    url: 'call-to-action',
                    method: values.callToActionId ? 'PUT' : 'POST',
                    data: { ...values },
                });
                if (!result.isAxiosError) {
                    setShowSuccess(true);
                    if (!values.callToActionId) {
                        window.location.href = '/cobrand-settings-feature/call-to-action/' + result.data;
                    }
                } else {
                    setShowError(true);
                }
            }}
            validateOnBlur
            isInitialValid={false}
        >
            {({ dirty, isValid, values, setFieldValue, handleSubmit }) => {
                return (
                    <Form style={{ maxWidth: '800px', marginBottom: 500 }}>
                        <div className="mt-1">
                            <label style={{ fontWeight: '500', marginBottom: 5 }}>Cobrand</label>
                            <Select
                                components={{ MenuList: CustomMenuList }}
                                options={cobrandsOptions}
                                placeholder="Cobrand"
                                name="cobrandId"
                                value={cobrandsOptions?.find(
                                    (option) => option.value === values.cobrandId
                                )}
                                onChange={(option) => {
                                    setFieldValue('cobrandId', option.value);
                                }}
                                isSearchable
                                styles={{
                                    menuList: (base) => ({
                                        ...base,
                                        maxHeight: "300px",
                                        overflowY: "auto",
                                    }),
                                    container: (base) => ({
                                        ...base,
                                        width: '100%',
                                    }),
                                    control: (base) => ({
                                        ...base,
                                        border: "1px solid #aaaaaa",
                                    }),
                                }}
                            />
                            <TextField label="Slug" placeholder="Enter Title" type="text" name="slug" />
                            <TextField label="Title" placeholder="Enter Title" type="text" name="title" />
                            <TextField label="Description" placeholder="Enter Title" type="text" name="description" />
                            <TextField label="Link Text" placeholder="Enter Title" type="text" name="linkText" />
                            <TextField label="Link Url" placeholder="Enter Title" type="text" name="linkUrl" />
                            <TextField label="Image Url" placeholder="Enter Title" type="text" name="imageUrl" />
                            <div style={{ marginTop: 8, display: 'flex', justifyContent: 'space-between' }}>
                                <ImageGallery
                                    setFieldValue={setFieldValue}
                                    fieldName="imageUrl" // Field name in Formik to update
                                    imageUrl="https://images.igrad.com/"
                                    blobUrl="https://igradcdnproduction.blob.core.windows.net"
                                    containerName="images"
                                    folderName="article_cta/"
                                />
                                <p style={{ marginTop: 5, fontSize: 12, color: 'red' }}>*Must be square ratio with a minimum of 290x290</p>
                            </div>
                            <img style={{ marginTop: 15, width: 200, height: 200 }} src={values.imageUrl} />
                            <hr />
                            <Toggle name="onForUs" label="OnForUs" onText="On" offText="Off" />
                            <Toggle name="onForInternational" label="OnForInternational" onText="On" offText="Off" />
                            {values.onForInternational && <Toggle name="countryOnOffDefault" label="CountryOnOffDefault" onText="On" offText="Off" />}

                            {values.onForInternational && values.countryOnOffDefault === false && <FluentSelect
                                options={countryOptions}
                                disabled={loadingCountries}
                                isMulti
                                name="countries"
                                label={`Countries`}
                                component={FluentSelect}
                            />}
                            <Toggle name="unitOnOffDefault" label="UnitOnOffDefault" onText="On" offText="Off" />
                            {values.unitOnOffDefault === false && values.cobrandId && <FluentSelect
                                options={unitsFormated && unitsFormated.filter(x => x.coBrandId === values.cobrandId)}
                                isMulti
                                name="units"
                                label={`Units`}
                                component={FluentSelect}
                            />}
                            <hr />
                            <Toggle name="showOnArticles" label="ShowOnArticles" onText="On" offText="Off" />
                            <Toggle name="showOnStart" label="ShowOnStart" onText="On" offText="Off" />
                            <Toggle name="showOnInfographics" label="ShowOnInfographics" onText="On" offText="Off" />
                            <Toggle name="showOnVideos" label="ShowOnVideos" onText="On" offText="Off" />
                            {(values.showOnArticles || values.showOnStart || values.showOnInfographics || values.showOnVideos) && <FluentSelect
                                options={conTags}
                                disabled={loadingTags}
                                isMulti
                                name="conTags"
                                label={`Tags`}
                                component={FluentSelect}
                            />}
                            <hr />
                            <Toggle name="showOnTools" label="ShowOnTools" onText="On" offText="Off" />
                            {values.showOnTools && <FluentSelect
                                options={getCtaToolOptions(tools, values.onForInternational)}
                                disabled={loadingTools}
                                isMulti
                                name="tools"
                                label={`Tools`}
                                component={FluentSelect}
                            />}
                            <Toggle name="showOnMeditations" label="ShowOnMeditations" onText="On" offText="Off" />
                            <Toggle name="showOnJournals" label="ShowOnJournals" onText="On" offText="Off" />
                            <hr />
                            <MSToggle
                                label="Show in Dashboard"
                                onText="Yes"
                                offText="No"
                                checked={isDropdownVisible || values.priorityOnCustomClientPage}
                                onChange={(e, checked) => handleToggleChange(checked, setFieldValue)}
                            />
                            {(isDropdownVisible || values.priorityOnCustomClientPage) && (
                                <FluentSelect
                                    options={dropdownOptions}
                                    name="priorityOnCustomClientPage"
                                    label={`PriorityOnCustomClientPage`}
                                    component={FluentSelect}
                                />
                            )}
                            <div style={{ display: 'flex' }} className="mt-1">
                                <PrimaryButton
                                    onClick={() => handleSubmit()}
                                    text={values.callToActionId ? 'Update' : 'Save'}
                                    disabled={!isValid || !dirty}
                                />
                            </div>
                        </div>
                        <SuccessComponent
                            successMessage="CTA Updated."
                            showSuccess={showSuccess}
                            setShowSuccess={setShowSuccess}
                        />
                        <ErrorComponent
                            errorMessage="Errors in form, check all tabs for highlighted fields."
                            showError={showError}
                            setShowError={setShowError}
                        />
                        <div></div>
                    </Form>
                );
            }}
        </Formik>
    );
};

export default CTA;
